<template>
  <div class="footer">
    <div class="inner">
      <p class="small"><a href="https://web-creates.com/contact/" target="_blank">お問い合わせ</a> / <a href="https://web-creates.com/privacy-policy/" target="_blank">プライバシーポリシー</a> / <a href="https://web-creates.com/disclaimer/" target="_blank">免責事項</a></p>
      <p class="copiright">©WEBクリ | マンダラート発想法</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.footer {
  .inner {
    padding: 3px 2% 350px;
    max-width: 1200px;
    margin: 0 auto;
    .small {
      font-size: 12px;
      a{
        color: #2c3e50;
        text-decoration: underline;
        margin: 0 10px;
      }
    }
    .copiright {
      font-size: 12px;
    }
  }
}

@media print{
  .footer{
    display: none;
  }
}
</style>
